<template>
  <div class="inline-block  w-full mt-10">
    <h1 class="mb-4">User Transaction History</h1>
    <el-table
      :data="data"
      :empty-text="'No Data available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Order Id">
      </el-table-column>
      <el-table-column
        prop="monetary"
        label="Date Purchased">
      </el-table-column>
      <el-table-column
        prop="frequency_score"
        label="Product Name">
      </el-table-column>
      <el-table-column
        prop="recency_score"
        label="Product Category">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Product SubCategory">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Order Quantity">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Unit Price">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="TAX">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Discount">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Sales">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Shipping Cost">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Order Quantity">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Unit Cost Price">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Total Cost Price">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Profit">
      </el-table-column>
      <el-table-column
        prop="monetary_score"
        label="Forecast Resupply date">
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TransactionHistory',
  data() {
    return {
      data: [],
    };
  },
};
</script>

<style scoped>

</style>
